import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "level", "componentType", "text", "title", "type", "direction", "placement", "onBack", "children", "actionItemsDirection", "backProps", "titlePostfix"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { useMediaQuery } from '@mui/material';
import { TextTooltip } from '../tooltip/textTooltip/textTooltip';
import { TitleContainer } from './titleStyles';
import { isTouchDevices } from '../utils/platformUtils';
import { useRtl } from '../rtlProvider';
export var EmbersTitle = function EmbersTitle(props) {
  var _backProps$tabIndex, _backProps$role;
  var intl = useIntl();
  var _useRtl = useRtl(),
    transformRTL = _useRtl.transformRTL;
  var isTouchDevice = isTouchDevices();
  var tabletViewScreen = useMediaQuery('(max-width:819px)');
  var className = props.className,
    _props$level = props.level,
    level = _props$level === void 0 ? 'secondary' : _props$level,
    componentType = props.componentType,
    _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    title = props.title,
    _props$type = props.type,
    type = _props$type === void 0 ? 'pageTitle' : _props$type,
    _props$direction = props.direction,
    direction = _props$direction === void 0 ? 'row' : _props$direction,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? isTouchDevice ? 'bottom-end' : type === 'pageTitle' ? 'right-start' : 'right' : _props$placement,
    onBack = props.onBack,
    children = props.children,
    _props$actionItemsDir = props.actionItemsDirection,
    actionItemsDirection = _props$actionItemsDir === void 0 ? 'row' : _props$actionItemsDir,
    backProps = props.backProps,
    titlePostfix = props.titlePostfix,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState('center'),
    _useState2 = _slicedToArray(_useState, 2),
    align = _useState2[0],
    setAlign = _useState2[1];
  var isPageTitle = type === 'pageTitle';
  var titleVariant;
  var titleTextWrap;
  if (level === 'primary') {
    if (isTouchDevice || tabletViewScreen) {
      titleVariant = isPageTitle ? 'body' : 'subtitleB';
      titleTextWrap = true;
    } else {
      titleVariant = isPageTitle ? 'headerD' : 'headerE';
      titleTextWrap = false;
    }
  } else {
    if (isTouchDevice || tabletViewScreen) {
      titleVariant = isPageTitle ? 'headerE' : 'subtitleB';
      titleTextWrap = false;
    } else {
      titleVariant = isPageTitle ? 'headerD' : 'headerE';
      titleTextWrap = false;
    }
  }
  var handleGoBackIconKeyDown = function handleGoBackIconKeyDown(e) {
    switch (e.key) {
      case 'Enter':
        e.stopPropagation();
        if (onBack) {
          onBack();
        }
        break;
      default:
        break;
    }
  };
  return /*#__PURE__*/React.createElement(TitleContainer, _extends({
    className: classnames('EmbersTitle-root', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      'EmbersTitle-pageTitle': isPageTitle,
      'EmbersTitle-appTitle': !isPageTitle
    }, "EmbersTitle-".concat(level), level), 'EmbersTitle-touchDevice', isTouchDevice || tabletViewScreen), "EmbersTitle-".concat(direction), direction), "EmbersTitle-".concat(align), align), 'EmbersTitle-hasTooltip', title), className)
  }, restProps), /*#__PURE__*/React.createElement("div", {
    className: "EmbersTitle-titleContainer"
  }, type === 'pageTitle' && level === 'secondary' && onBack &&
  /*#__PURE__*/
  // Different styling than other Ember buttons
  React.createElement("i", _extends({
    className: classnames('EmbersTitle-back', transformRTL('icon-arrow-left', 'icon-arrow-right')),
    tabIndex: (_backProps$tabIndex = backProps === null || backProps === void 0 ? void 0 : backProps.tabIndex) !== null && _backProps$tabIndex !== void 0 ? _backProps$tabIndex : 0,
    onClick: onBack,
    onKeyDown: handleGoBackIconKeyDown,
    role: (_backProps$role = backProps === null || backProps === void 0 ? void 0 : backProps.role) !== null && _backProps$role !== void 0 ? _backProps$role : 'button',
    "aria-label": intl.formatMessage({
      id: 'embers.button.back',
      defaultMessage: 'Back'
    })
  }, backProps === null || backProps === void 0 ? void 0 : backProps.ariaProps)), /*#__PURE__*/React.createElement(TextTooltip, {
    tooltipProps: title ? {
      title: title,
      placement: placement,
      type: 'info',
      size: isPageTitle ? 'large' : 'small'
    } : undefined,
    typographyProps: {
      variant: titleVariant,
      noWrap: !titleTextWrap,
      className: 'EmbersTitle-title',
      componentType: componentType || (isPageTitle ? 'h2' : 'h1')
    },
    tabIndex: 0
  }, text), titlePostfix && /*#__PURE__*/React.createElement("span", {
    className: "EmbersTitle-postfix"
  }, titlePostfix)), /*#__PURE__*/React.createElement("div", {
    className: classnames('EmbersTitle-actionContainer', {
      'EmbersTitle-actionContainer-column': actionItemsDirection === 'column'
    })
  }, children));
};